module.exports = __webpack_public_path__ + "static/media/ben.bfcfb5bb.png";